import { render, staticRenderFns } from "./CDUseBalance.vue?vue&type=template&id=37e8b57d&scoped=true&"
import script from "./CDUseBalance.vue?vue&type=script&lang=js&"
export * from "./CDUseBalance.vue?vue&type=script&lang=js&"
import style0 from "./CDUseBalance.vue?vue&type=style&index=0&id=37e8b57d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e8b57d",
  null
  
)

export default component.exports